import "./type.scss"

